import { Pipe, PipeTransform } from '@angular/core';
import { StepState } from './../step.state';

@Pipe({
  name: 'sectionStepProgress'
})
export class SectionStepProgressPipe implements PipeTransform {
  transform(state: StepState): string | null {
    if (!state.useSections || !state.onboardingSections.length) {
      return null;
    }

    let accumulatedSteps = 0;
    for (const section of state.onboardingSections) {
      const sectionStart = accumulatedSteps;
      const sectionEnd = accumulatedSteps + section.length;
      
      if (state.step < sectionEnd) {
        const stepInSection = state.step - sectionStart + 1;
        return `${stepInSection}/${section.length}`;
      }
      accumulatedSteps = sectionEnd;
    }

    // Если шаг превышает все секции, показываем прогресс последней секции
    const lastSection = state.onboardingSections[state.onboardingSections.length - 1];
    const stepInLastSection = Math.min(state.step - (accumulatedSteps - lastSection.length) + 1, lastSection.length);
    return `${stepInLastSection}/${lastSection.length}`;
  }
}
